// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/staff')({
  staticData: { screenId: 'ConsoleStaffScreen', access: 'platform.staff.manage' },
  component: ConsoleStaffScreen,
})

function ConsoleStaffScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsoleStaffScreen">
      <PageHeader title={t('shell.nav.staff')} titleTestId="consoleStaff_titleValue" />
    </main>
  )
}
